export default __webpack_public_path__ + "static/media/binance-logo.18017344.svg";